import { render } from "./FixedBottomNavbar.vue?vue&type=template&id=6fd87720&scoped=true"
import script from "./FixedBottomNavbar.vue?vue&type=script&lang=js"
export * from "./FixedBottomNavbar.vue?vue&type=script&lang=js"

import "./FixedBottomNavbar.vue?vue&type=style&index=0&id=6fd87720&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd87720"]])

export default __exports__